module.exports = __webpack_public_path__ + "img/kristian-suhartono.53448656.png";